"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var CategoryCard_1 = __importDefault(require("../CategoryCard"));
var Transition_1 = __importDefault(require("react-transition-group/Transition"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var swr_hooks_1 = require("@l2p/swr-hooks");
var CategoriesList = function (_a) {
    var isOpened = _a.isOpened, categories = _a.categories, currentCategoryId = _a.currentCategoryId, onItemClick = _a.onItemClick;
    var translateLocale = (0, swr_hooks_1.useLocaleTranslations)();
    return (react_1.default.createElement(Transition_1.default, { in: isOpened, timeout: 10 }, function (state) { return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container, style: {
            opacity: state === 'entering' || state === 'exited' ? 0 : 1,
            maxHeight: state === 'entering' || state === 'exited' ? '0px' : '100%',
        } }, categories === null || categories === void 0 ? void 0 : categories.map(function (category) { return (react_1.default.createElement(CategoryCard_1.default, { key: category.id, active: currentCategoryId === (category === null || category === void 0 ? void 0 : category.id), title: translateLocale(category.title), onClick: function () {
            if (onItemClick) {
                if (currentCategoryId === (category === null || category === void 0 ? void 0 : category.id))
                    onItemClick(null);
                else
                    onItemClick(category);
            }
        } })); }))); }));
};
exports.default = (0, react_1.memo)(CategoriesList);
